import BigNumber from 'big.js';
import Format from 'toformat';

const BigWithFormat: BigWithFormatStatic = Format(BigNumber);
type BigSource = BigNumber.BigSource | null | undefined;

export interface BigWithFormatInstance extends BigNumber {
  toFormat(dp?: number, rm?: number, format?: BigFormat): string;
}

export interface BigWithFormatStatic {
  (value: BigNumber.BigSource): BigWithFormatInstance;
  new (value: BigNumber.BigSource): BigWithFormatInstance;

  readonly prototype: BigWithFormatInstance;

  format: BigFormat;
}

export interface BigFormat {
  decimalSeparator?: string;
  groupSeparator?: string;
  groupSize?: number;
  secondaryGroupSize?: number;
  fractionGroupSeparator?: string;
  fractionGroupSize?: number;
}

BigWithFormat.format = Object.freeze({
  decimalSeparator: '.',
  groupSeparator: ',',
  groupSize: 3,
  secondaryGroupSize: 0,
  fractionGroupSeparator: '',
  fractionGroupSize: 0,
});

export const BigOrZero: (v: BigSource) => BigWithFormatInstance = (
  num: BigSource
) => BigWithFormat(num || '0'); // handle '', undefined, zero and null as 0

export const BigOrNull: (v: BigSource) => BigWithFormatInstance | null = (
  num: BigSource
) => (num === undefined || num === null || '' ? null : BigWithFormat(num));
